import Toggle from "./Toggle";

interface VisibilitySwitchesProps {
  isBizShow: boolean;
  isHideHp: boolean;
  isHideBirth: boolean;
  onChange: (
    key: "is_biz_show" | "is_hide_hp" | "is_hide_birth",
    value: boolean
  ) => void;
}

// 연락처 공개 설정 (켜면 숨김)
export default function VisibilitySwitches({
  isBizShow,
  isHideHp,
  isHideBirth,
  onChange,
}: VisibilitySwitchesProps) {
  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <h2 className="font-heading text-base font-bold text-foreground-900">공개 설정</h2>
      <div className="mt-4 space-y-3">
        <Toggle
          id="is_biz_show"
          checked={isBizShow}
          onChange={(v) => onChange("is_biz_show", v)}
          label="명함·지도에 직장 정보 공개"
          description="끄면 명함과 지도에서 직장 정보가 숨겨집니다."
        />
        <Toggle
          id="is_hide_hp"
          checked={isHideHp}
          onChange={(v) => onChange("is_hide_hp", v)}
          label="휴대폰 비공개"
          description="켜면 휴대폰 번호가 명함에 표시되지 않습니다."
        />
        <Toggle
          id="is_hide_birth"
          checked={isHideBirth}
          onChange={(v) => onChange("is_hide_birth", v)}
          label="생일 비공개"
          description="켜면 생일이 명함에 표시되지 않습니다."
        />
      </div>
    </section>
  );
}